/**
 * Shopify Custom Wishlist Plugin v3
 */
(function () {
  'use strict';

  const cfg        = window.WishlistConfig || {};
  const API_URL    = (cfg.apiUrl    || '').replace(/\/$/, '');
  const API_SECRET = cfg.apiSecret  || '';
  const CURRENCY   = cfg.currency   || '₹';

  if (!API_URL) {
    console.warn('[Wishlist] WishlistConfig.apiUrl is not set. Plugin disabled.');
    return;
  }

  const LS_NAME_KEY  = 'wl_name';
  const LS_PHONE_KEY = 'wl_phone';
  const LS_ITEMS_KEY = 'wl_items';
  const LS_DATA_KEY  = 'wl_data';

  // ── Local state helpers ─────────────────────────────────
  function getName()    { return localStorage.getItem(LS_NAME_KEY)  || ''; }
  function saveName(n)  { localStorage.setItem(LS_NAME_KEY, n); }
  function getPhone()   { return localStorage.getItem(LS_PHONE_KEY) || ''; }
  function savePhone(p) { localStorage.setItem(LS_PHONE_KEY, p); }

  function getLocalItems() {
    try { return JSON.parse(localStorage.getItem(LS_ITEMS_KEY) || '{}'); }
    catch { return {}; }
  }
  function setLocalItem(id, val) {
    const items = getLocalItems();
    if (val) items[String(id)] = true;
    else delete items[String(id)];
    localStorage.setItem(LS_ITEMS_KEY, JSON.stringify(items));
    updateCounter();
  }
  function isWishlisted(id) { return !!getLocalItems()[String(id)]; }

  function getLocalData() {
    try { return JSON.parse(localStorage.getItem(LS_DATA_KEY) || '{}'); }
    catch { return {}; }
  }
  function saveLocalData(productData) {
    const data = getLocalData();
    data[String(productData.product_id)] = productData;
    localStorage.setItem(LS_DATA_KEY, JSON.stringify(data));
  }
  function removeLocalData(productId) {
    const data = getLocalData();
    delete data[String(productId)];
    localStorage.setItem(LS_DATA_KEY, JSON.stringify(data));
  }

  // ── Resolved user identity ──────────────────────────────
  // Two scenarios only:
  //   1) Returning user  — wl_phone exists in localStorage → skip modal
  //   2) New user        — no phone found → open modal
  function resolvedPhone() {
    return getPhone();
  }
  function resolvedName() {
    return getName();
  }

  // ── API calls ───────────────────────────────────────────
  async function apiCall(method, body) {
    const opts = {
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-wishlist-secret': API_SECRET,
      },
    };
    if (body && method !== 'GET' && method !== 'HEAD') {
      opts.body = JSON.stringify(body);
    }
    const url = method === 'GET'
      ? `${API_URL}/api/wishlist?phone=${encodeURIComponent(body.phone)}`
      : `${API_URL}/api/wishlist`;
    const res = await fetch(url, opts);
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${res.status}`);
    }
    return res.json();
  }

  async function apiAdd(phone, productData)   { return apiCall('POST',   { phone, ...productData }); }
  async function apiRemove(phone, product_id) { return apiCall('DELETE', { phone, product_id }); }
  async function apiGet(phone)                { return apiCall('GET',    { phone }); }

  // ── Sync from server ────────────────────────────────────
  async function syncFromServer() {
    const phone = resolvedPhone();
    updateCounter();
    if (!phone) return;

    try {
      const data = await apiGet(phone);
      const serverItems = data.wishlist || [];

      if (serverItems.length > 0) {
        const fresh = {};
        const dataCache = {};
        serverItems.forEach(entry => {
          fresh[entry.product_id] = true;
          dataCache[entry.product_id] = {
            product_id:       entry.product_id,
            product_title:    entry.product_title,
            product_handle:   entry.product_handle,
            variant_id:       entry.variant_id,
            product_image:    entry.product_image,
            product_price:    entry.product_price,
            compare_at_price: entry.compare_at_price || '',
            added_at:         entry.added_at,
          };
        });
        localStorage.setItem(LS_ITEMS_KEY, JSON.stringify(fresh));
        localStorage.setItem(LS_DATA_KEY, JSON.stringify(dataCache));
      }

      updateAllButtons();
      updateCounter();

      if (window.WishlistPage && typeof window.WishlistPage.refresh === 'function') {
        window.WishlistPage.refresh();
      }
    } catch (e) {
      console.warn('[Wishlist] Sync failed:', e.message);
      updateCounter();
    }
  }

  // ── Counter (badge in header) ───────────────────────────
  function updateCounter() {
    const items = getLocalItems();
    const count = Object.keys(items).length;

    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      if (count > 0) {
        el.style.cssText = 'display: flex !important; align-items: center; justify-content: center;';
        el.classList.add('is-visible');
        el.setAttribute('data-count', count);
      } else {
        el.style.cssText = 'display: none !important;';
        el.classList.remove('is-visible');
        el.removeAttribute('data-count');
      }
    });

    document.querySelectorAll('[data-wishlist-link]').forEach(el => {
      el.classList.toggle('has-items', count > 0);
    });
  }

  // ── Heart SVG state ─────────────────────────────────────
  function updateHeartSVG(btn) {
    const active = btn.classList.contains('is-wishlisted');
    btn.querySelectorAll('svg, svg g, svg path').forEach(el => {
      el.removeAttribute('style');
      if (active) {
        el.style.fill        = '#e63946';
        el.style.stroke      = '#e63946';
        el.style.strokeWidth = '2';
        el.style.opacity     = '1';
      } else {
        el.style.fill        = 'none';
        el.style.stroke      = '#333';
        el.style.strokeWidth = '4';
        el.style.opacity     = '1';
      }
    });
  }

  // ── Button state ────────────────────────────────────────
  function updateAllButtons() {
    document.querySelectorAll('.wishlist-btn[data-product-id]').forEach(btn => {
      const id     = btn.dataset.productId;
      const active = isWishlisted(id);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-label',   active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-pressed', String(active));
      updateHeartSVG(btn);
    });
  }

  function setButtonLoading(btn, loading) {
    btn.disabled = loading;
    if (loading) btn.classList.add('wl-loading');
    else btn.classList.remove('wl-loading');
  }

  // ── Toast ───────────────────────────────────────────────
  let toastTimer = null;
  function showToast(msg, type = 'success') {
    let toast = document.getElementById('wl-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wl-toast';
      toast.className = 'wl-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.className = `wl-toast is-${type}`;
    void toast.offsetHeight;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  // ── Modal ───────────────────────────────────────────────
  let pendingProductData = null;
  let pendingButton      = null;

  function openModal(btn, productData) {
    pendingProductData = productData;
    pendingButton      = btn;
    const overlay = document.getElementById('wl-modal-overlay');
    if (!overlay) return;

    const nameEl  = overlay.querySelector('.wl-modal__product-name');
    const priceEl = overlay.querySelector('.wl-modal__product-price');
    const imgEl   = overlay.querySelector('.wl-modal__product-img');
    const phEl    = overlay.querySelector('.wl-modal__product-img-placeholder');

    if (nameEl)  nameEl.textContent  = productData.product_title || '';
    if (priceEl) {
      const cleanPrice = (productData.product_price || '').toString().replace(/[.,]00$/, '');
      priceEl.textContent = productData.product_price ? `${CURRENCY}${cleanPrice}` : '';
    }

    if (productData.product_image) {
      if (imgEl) { imgEl.src = productData.product_image; imgEl.style.display = 'block'; }
      if (phEl)   phEl.style.display = 'none';
    } else {
      if (imgEl)  imgEl.style.display = 'none';
      if (phEl)   phEl.style.display = 'flex';
    }

    const nameInput = overlay.querySelector('#wl-name-input');
    if (nameInput && getName()) nameInput.value = getName();

    const contactInput = overlay.querySelector('#wl-contact-input');
    if (contactInput && getPhone()) contactInput.value = getPhone();

    showModalForm(overlay);
    clearAllErrors(overlay);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (nameInput && !nameInput.value) {
      setTimeout(() => nameInput.focus(), 250);
    } else if (contactInput) {
      setTimeout(() => contactInput.focus(), 250);
    }
  }

  function closeModal() {
    const overlay = document.getElementById('wl-modal-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    pendingProductData = null;
    pendingButton      = null;
  }

  function showModalForm(overlay) {
    overlay.querySelector('.wl-modal__form-section').style.display = 'block';
    overlay.querySelector('.wl-modal__success').classList.remove('is-visible');
  }
  function showModalSuccess(overlay) {
    overlay.querySelector('.wl-modal__form-section').style.display = 'none';
    overlay.querySelector('.wl-modal__success').classList.add('is-visible');
    setTimeout(() => closeModal(), 1800);
  }

  // ── Error helpers ───────────────────────────────────────
  function showFieldError(overlay, inputSelector, errorSelector, msg) {
    const errEl = overlay.querySelector(errorSelector);
    const input = overlay.querySelector(inputSelector);
    if (errEl) { errEl.textContent = msg; errEl.classList.add('is-visible'); }
    if (input) input.classList.add('has-error');
  }

  function clearFieldError(overlay, inputSelector, errorSelector) {
    const errEl = overlay.querySelector(errorSelector);
    const input = overlay.querySelector(inputSelector);
    if (errEl) { errEl.textContent = ''; errEl.classList.remove('is-visible'); }
    if (input) input.classList.remove('has-error');
  }

  function clearAllErrors(overlay) {
    clearFieldError(overlay, '#wl-name-input',    '#wl-name-error');
    clearFieldError(overlay, '#wl-contact-input', '#wl-phone-error');
  }

  // ── Validation ──────────────────────────────────────────
  function validateContact(value) {
    const v = value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(v)) return null;
    const digits = v.replace(/\D/g, '');
    if (digits.length === 10) return null;
    return 'Please enter a valid 10-digit phone number or email address.';
  }

  async function submitModal() {
    const overlay      = document.getElementById('wl-modal-overlay');
    const contactInput = overlay.querySelector('#wl-contact-input');
    const nameInput    = overlay.querySelector('#wl-name-input');
    const btn          = overlay.querySelector('#wl-modal-submit');
    if (!contactInput || !overlay) return;

    const contact = contactInput.value.trim();
    const name    = nameInput ? nameInput.value.trim() : '';

    clearAllErrors(overlay);

    let hasError = false;

    if (!name) {
      showFieldError(overlay, '#wl-name-input', '#wl-name-error', 'Please enter your name.');
      hasError = true;
    }

    const contactErr = validateContact(contact);
    if (contactErr) {
      showFieldError(overlay, '#wl-contact-input', '#wl-phone-error', contactErr);
      hasError = true;
    }

    if (hasError) {
      if (!name && nameInput) nameInput.focus();
      else if (contactErr && contactInput) contactInput.focus();
      return;
    }

    btn.disabled    = true;
    btn.textContent = 'Saving...';

    try {
      const dataToSend = { ...pendingProductData, customer_name: name };
      await apiAdd(contact, dataToSend);
      savePhone(contact);
      saveName(name);
      setLocalItem(pendingProductData.product_id, true);
      saveLocalData(pendingProductData);

      updateAllButtons();
      if (pendingButton) {
        pendingButton.classList.add('wl-animate');
        setTimeout(() => pendingButton.classList.remove('wl-animate'), 400);
      }
      showModalSuccess(overlay);
    } catch (e) {
      showFieldError(overlay, '#wl-contact-input', '#wl-phone-error', 'Something went wrong. Please try again.');
      console.error('[Wishlist] Add failed:', e);
    } finally {
      btn.disabled    = false;
      btn.textContent = 'Save to Wishlist';
    }
  }

  // ── Click handler ───────────────────────────────────────
  async function handleWishlistClick(btn) {
    const productId = btn.dataset.productId;
    if (!productId) return;

    const productData = {
      product_id:       productId,
      product_title:    btn.dataset.productTitle  || '',
      product_handle:   btn.dataset.productHandle || '',
      variant_id:       btn.dataset.variantId     || '',
      product_image:    btn.dataset.productImage  || '',
      product_price:    btn.dataset.productPrice  || '',
      compare_at_price: btn.dataset.comparePrice  || '',
    };

    // ── REMOVE flow ─────────────────────────────────────
    if (isWishlisted(productId)) {
      const phone = resolvedPhone();
      setButtonLoading(btn, true);
      
      // Try to remove from API if phone exists, but don't fail if it does
      if (phone) {
        try {
          await apiRemove(phone, productId);
        } catch (e) {
          console.warn('[Wishlist] API remove failed, removing locally:', e.message);
          // Continue with local removal even if API fails
        }
      }
      
      // Always remove locally
      setLocalItem(productId, false);
      removeLocalData(productId);
      updateAllButtons();
      showToast('Removed from wishlist', 'success');
      
      if (window.WishlistPage && typeof window.WishlistPage.refresh === 'function') {
        window.WishlistPage.refresh();
      }
      
      setButtonLoading(btn, false);
      return;
    }

    // ── ADD flow ────────────────────────────────────────
    const phone = resolvedPhone();
    const name  = resolvedName();

    if (phone) {
      setButtonLoading(btn, true);
      try {
        const dataToSend = { ...productData, customer_name: name };
        await apiAdd(phone, dataToSend);
        setLocalItem(productId, true);
        saveLocalData(productData);

        updateAllButtons();
        btn.classList.add('wl-animate');
        setTimeout(() => btn.classList.remove('wl-animate'), 400);
        showToast('Added to wishlist!', 'success');
      } catch (e) {
        showToast('Could not add to wishlist. Try again.', 'error');
      } finally {
        setButtonLoading(btn, false);
      }
      return;
    }

    // No phone found → open modal
    openModal(btn, productData);
  }

  function initButtons() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.wishlist-btn[data-product-id]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        handleWishlistClick(btn);
      }
    });
  }

  function initModal() {
    const overlay = document.getElementById('wl-modal-overlay');
    if (!overlay) return;

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    overlay.querySelector('.wl-modal__close')?.addEventListener('click', closeModal);
    overlay.querySelector('#wl-modal-submit')?.addEventListener('click', submitModal);

    overlay.querySelector('#wl-name-input')?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const contactInput = overlay.querySelector('#wl-contact-input');
        if (contactInput && !contactInput.value.trim()) {
          contactInput.focus();
        } else {
          submitModal();
        }
      }
    });

    overlay.querySelector('#wl-contact-input')?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitModal(); }
    });

    overlay.querySelector('#wl-name-input')?.addEventListener('input', function () {
      clearFieldError(overlay, '#wl-name-input', '#wl-name-error');
    });
    overlay.querySelector('#wl-contact-input')?.addEventListener('input', function () {
      clearFieldError(overlay, '#wl-contact-input', '#wl-phone-error');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ── Helpers ─────────────────────────────────────────────
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ── Wishlist page renderer ──────────────────────────────
  // Fetches the *real* product-card markup (same snippet used on the collection
  // page) via the Section Rendering API, so tag badges, star-rating badge, price
  // and size options are always identical to the collection page. This reuses
  // the same "id:X OR id:Y" search technique the theme already uses for
  // recently-viewed-products.
  async function fetchWishlistCards(ids) {
    const query = ids.map(id => `id:${id}`).join(' OR ');
    const url   = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=wishlist-render`;

    const map = {};
    try {
      const res = await fetch(url);
      if (!res.ok) return map;
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');
      const results = doc.getElementById('wishlist-render-results');
      if (!results) return map;

      results.querySelectorAll('product-card').forEach(card => {
        const wlBtn  = card.querySelector('.wishlist-btn[data-product-id]');
        const handle = card.getAttribute('handle');
        if (wlBtn) map[wlBtn.dataset.productId] = card;
        if (handle) map['handle:' + handle] = card;
      });
    } catch (e) {
      console.warn('[Wishlist] Failed to fetch product cards:', e.message);
    }
    return map;
  }

  // Fetch a product's real variant/option data via the standard Shopify
  // Ajax API. The collection-grid card only shows sizes as plain text
  // badges that link straight to the PDP (no per-size variant id), so this
  // is what actually lets us build a clickable size selector here.
  async function fetchProductJSON(handle) {
    if (!handle) return null;
    try {
      const res = await fetch(`${Shopify.routes.root}products/${handle}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function extractHandle(cardEl, localData) {
    const url = cardEl.getAttribute('data-product-url') || '';
    const match = url.match(/\/products\/([a-zA-Z0-9\-]+)/);
    if (match) return match[1];
    return (localData && localData.product_handle) || '';
  }

  async function buildCardWrapper(cardEl, productId, localData) {
    const wlBtn      = cardEl.querySelector('.wishlist-btn[data-product-id]');
    const available  = !!wlBtn;
    let   variantId  = wlBtn ? wlBtn.dataset.variantId : '';
    const handle     = extractHandle(cardEl, localData);

    const wrapper = document.createElement('div');
    wrapper.className = 'product-card-wrapper wl-product-card-wrapper';
    wrapper.setAttribute('data-product-handle', handle);
    wrapper.setAttribute('data-product-id', productId);
    wrapper.appendChild(cardEl);

    // Hide the theme's own read-only size badges on the cloned card — they
    // just link back to the PDP. Our own clickable selector replaces them.
    const nativeSizes = cardEl.querySelector('.product-grid--sizes');
    if (nativeSizes) nativeSizes.style.display = 'none';

    // ── Size selector (rendered above Add to Cart) ──────────
    // If the product has a "Size" option, fetch its variants and build a
    // row of clickable size buttons. A size must be chosen before Add to
    // Cart is enabled.
    let requiresSize = false;
    let sizeButtons  = [];

    if (available) {
      const productJSON = await fetchProductJSON(handle);
      if (productJSON && Array.isArray(productJSON.options)) {
        const sizeOption = productJSON.options.find(o => /size/i.test(o.name));
        if (sizeOption) {
          const key = ['option1', 'option2', 'option3'][sizeOption.position - 1];
          const byValue = {};
          productJSON.variants.forEach(v => {
            const value = v[key];
            if (value == null) return;
            if (!byValue[value] || (!byValue[value].available && v.available)) {
              byValue[value] = v;
            }
          });
          sizeOption.values.forEach(value => {
            if (byValue[value]) sizeButtons.push({ value, variant: byValue[value] });
          });
          requiresSize = sizeButtons.length > 0;
        }
      }
    }

    if (requiresSize) {
      const label = document.createElement('p');
      label.className = 'wl-size-label';
      label.textContent = 'Select Size';
      wrapper.appendChild(label);

      const sizeList = document.createElement('div');
      sizeList.className = 'wl-size-list';
      wrapper.appendChild(sizeList);

      const buttons = sizeButtons.map(({ value, variant }) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wl-size-swatch' + (variant.available ? '' : ' wl-size-swatch--oos');
        btn.textContent = value;
        btn.disabled = !variant.available;
        btn.dataset.variantId = variant.id;
        sizeList.appendChild(btn);
        return btn;
      });

      // Pre-select the size matching the previously wishlisted variant, if
      // it's still available.
      const preselected = buttons.find(b => !b.disabled && b.dataset.variantId === String(variantId));
      if (preselected) {
        preselected.classList.add('is-selected');
      } else {
        variantId = '';
      }

      buttons.forEach(btn => {
        if (btn.disabled) return;
        btn.addEventListener('click', function () {
          buttons.forEach(b => b.classList.remove('is-selected'));
          this.classList.add('is-selected');
          variantId = this.dataset.variantId;

          const input = wrapper.querySelector(`#wl-variant-input-${esc(productId)}`);
          if (input) input.value = variantId;

          const cartBtn = wrapper.querySelector('.wl-add-to-cart-btn');
          if (cartBtn) {
            cartBtn.disabled = false;
            cartBtn.textContent = 'Add to Cart';
          }
        });
      });
    }

    const formId = `wl-form-${esc(productId)}`;
    const needsSizeStill = requiresSize && !variantId;
    wrapper.insertAdjacentHTML('beforeend', `
      <form id="${formId}" method="post" action="${Shopify.routes.root}cart/add.js" accept-charset="UTF-8" style="display:none;">
        <input type="hidden" id="wl-variant-input-${esc(productId)}" name="id" value="${esc(variantId)}">
        <input type="hidden" name="quantity" value="1">
      </form>
      ${available
        ? `<button type="button" class="button button--primary wl-add-to-cart-btn" data-requires-size="${requiresSize}" ${needsSizeStill ? 'disabled' : ''} onclick="window.submitWishlistCart(event, '${formId}')" style="width:100%;margin-top:10px;">${needsSizeStill ? 'Select a Size' : 'Add to Cart'}</button>`
        : `<button type="button" class="button button--secondary wl-add-to-cart-btn" disabled style="width:100%;margin-top:10px;">Sold Out</button>`}
    `);

    return wrapper;
  }

  // ── Empty state UI ──────────────────────────────────────
  function showEmptyState() {
    const container = document.getElementById('wl-product-grid');
    const heading   = document.getElementById('wl-page-heading');
    if (heading) heading.textContent = 'My Wishlist (0 Items)';
    if (container) container.innerHTML = `
      <div style="grid-column:1/-1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;text-align:center;">
        <div style="width:80px;height:80px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;margin-bottom:24px;">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </div>
        <h2 style="font-size:18px;font-weight:700;margin:0 0 10px;">Your Wishlist is empty.</h2>
        <p style="color:#888;font-size:14px;margin:0 0 24px;">Browse products and save the ones<br>you love.</p>
        <a href="/collections/all" style="display:inline-block;background:#000;color:#fff;font-weight:700;font-size:13px;letter-spacing:0.1em;padding:14px 36px;border-radius:50px;text-decoration:none;transition:background 0.2s;">BROWSE PRODUCTS</a>
      </div>`;
  }

  async function renderWishlistPage() {
    const container = document.getElementById('wl-product-grid');
    const heading   = document.getElementById('wl-page-heading');
    if (!container) return;

    const items = getLocalItems();
    const data  = getLocalData();
    const ids   = Object.keys(items);

    if (!ids.length) {
      showEmptyState();
      return;
    }

    // Show skeleton loaders
    container.innerHTML = ids.map(() => `
      <div class="product-card-wrapper wl-product-card-wrapper" style="opacity:0.4;">
        <product-card class="product-card product-card--blends">
          <div class="product-card__figure">
            <div style="aspect-ratio:1/1;background:#eee;display:block;"></div>
          </div>
          <div class="product-card__info">
            <div style="height:14px;background:#eee;border-radius:4px;margin-bottom:8px;"></div>
            <div style="height:14px;background:#eee;border-radius:4px;width:60%;"></div>
          </div>
        </product-card>
      </div>`).join('');

    const cardMap = await fetchWishlistCards(ids);

    const entries = [];
    ids.forEach(id => {
      const localData = data[id];
      let cardEl = cardMap[id];
      if (!cardEl && localData && localData.product_handle) {
        cardEl = cardMap['handle:' + localData.product_handle];
      }
      if (cardEl) entries.push({ id, cardEl });
    });

    // Clean up stale localStorage entries for products that no longer exist / didn't match
    ids.forEach(id => {
      if (!entries.find(e => e.id === id)) {
        setLocalItem(id, false);
        removeLocalData(id);
      }
    });

    if (!entries.length) {
      showEmptyState();
      return;
    }

    if (heading) heading.textContent = `My Wishlist - ${entries.length} Item${entries.length === 1 ? '' : 's'}`;

    container.innerHTML = '';
    const wrapperEls = await Promise.all(
      entries.map(({ id, cardEl }) => buildCardWrapper(cardEl.cloneNode(true), id, data[id]))
    );
    wrapperEls.forEach(el => container.appendChild(el));

    updateAllButtons();
  }

  async function removeFromWishlistAndRefresh(productId) {
    const phone = resolvedPhone();
    if (phone) {
      try { await apiRemove(phone, productId); } catch (e) { /* silent */ }
    }
    setLocalItem(productId, false);
    removeLocalData(productId);
    updateAllButtons();
    showToast('Removed from wishlist', 'success');
    renderWishlistPage();
  }

  // ── Add to Cart via AJAX (for wishlist page) ────────────
  // Mirrors this theme's own <product-form> submit handler
  // (assets/component-product-form.js) so the cart drawer opens exactly the
  // way it does everywhere else in the theme:
  //  1) POST to cart/add.js with sections=cart-drawer so Shopify renders the
  //     cart-drawer section HTML in the same response
  //  2) window.eventBus.emit('update:cart:drawer', responseJson) — this is
  //     what <cart-drawer> (component-cart-drawer.js) listens for to refresh
  //     its contents from responseJson.sections['cart-drawer']
  //  3) window.eventBus.emit('open:cart:drawer', { scrollToTop: true }) —
  //     this is what actually opens the drawer
  // The previous version dispatched "variant:add"/"cart:change" DOM events,
  // which nothing in this theme listens for (this theme uses window.eventBus,
  // not DOM CustomEvents), so the item was added to the cart but the drawer
  // never opened.
  window.submitWishlistCart = function(event, formId) {
    event.preventDefault();
    const form = document.getElementById(formId);
    if (!form) return;

    const button = event.target;
    const originalText = button.textContent;

    if (button.dataset.requiresSize === 'true' && !new FormData(form).get('id')) {
      showToast('Please select a size first.', 'error');
      return;
    }

    button.disabled = true;
    button.textContent = 'Adding...';

    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer');

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json().then(data => ({ ok: response.ok, data })))
    .then(({ ok, data }) => {
      if (!ok) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      // Refresh the cart drawer markup, then open it — same two calls the
      // theme's own add-to-cart button makes.
      window.eventBus.emit('update:cart:drawer', data);
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });

      // Keep the little cart-count bubble in the header in sync.
      fetch(`${Shopify.routes.root}cart.js`)
        .then(res => res.json())
        .then(cart => { if (window.wetheme) window.wetheme.updateCartCount(cart); })
        .catch(() => {});

      button.textContent = 'Added!';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 800);
    })
    .catch(error => {
      console.error('[Wishlist] Add to cart error:', error);
      showToast('Could not add to cart. Try again.', 'error');
      button.disabled = false;
      button.textContent = originalText;
    });
  };

  function boot() {
    updateAllButtons();
    updateCounter();
    initButtons();
    initModal();
    setInterval(updateCounter, 1000);
    syncFromServer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.WishlistPlugin = {
    updateAllButtons,
    updateCounter,
    openModal,
    getLocalItems,
    getLocalData,
    isWishlisted,
    apiRemove,
    setLocalItem,
    removeLocalData,
    getPhone: resolvedPhone,
    getName:  resolvedName,
    removeFromWishlistAndRefresh,
  };

  window.WishlistPage = {
    refresh: renderWishlistPage,
  };

})();